import axios from '@/utils/fetch'

export default {
    //     https://apis.map.qq.com/ws/location/v1/ip 
    //
    //
    //
    //
    // 响应结果
    // 名称			类型			必填			说明
    // status			number			是			状态码，0为正常,
    // 310请求参数信息有误，
    // 311Key格式错误,
    // 306请求有护持信息请检查字符串,
    // 110请求来源未被授权
    // message			string			是			状态说明
    // result			object			是			IP定位结果
    // ip			string			是			用于定位的IP地址
    // location			object			是			定位坐标
    // lat			number			是			纬度
    // lng			number			是			经度
    // ad_info			object			是			定位行政区划信息
    // nation			string			是			国家
    // province			string			是			省
    // city			string			否			市
    // district			string			否			区
    // adcode			number			是			行政区划代码
    // 获取微信公众号授权第三方平台链接
    // , // 服务条款
    location() {
        return axios({
            url: `ws/location/v1/ip`,
            baseURL: 'http://apis.map.qq.com/',
            params: {
                // ip: null,//			否			IP地址，缺省时会使用请求端的IP			 ip=202.106.0.20
                key: 'ZEWBZ-ESPWX-7JP4E-ZPTIZ-KDW6E-VHFPN',//			是			开发密钥（Key）			key=OB4BZ-D4W3U-B7VVO-4PJWW-6TKDJ-WPB77
                output: 'JSONP',//			否			返回格式：支持JSON/JSONP，默认JSON			output=json
                // callback: null,//			否			JSONP方式回调函数			callback=function1
            },
            responseType: 'JSONP',
            dataType: "JSONP", //跨域不能用json只能用jsonp
            headers: {
                dataType: "JSONP", //跨域不能用json只能用jsonp
            },
            method: "GET",
        })
    },
}


// WEBPACK FOOTER //
// ./src/apis/src/map.js